import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ICustomColumns {
  children: ReactNode;
  columns: number[];
  className?: string;
}

export function UserContentLabel({ children }: { children: string }) {
  return <p className="typo-body-regular-paragraph text-tertiary font-bold">{children}</p>;
}

export function UserContentCustomColumns({ children, columns, className }: ICustomColumns) {
  return (
    <div className={twMerge(`grid grid-cols-[${columns.map((col) => `${col}fr`).join('_')}] items-center`, className)}>
      {children}
    </div>
  );
}

export function UserContentSubSection({ children, title }: { children: ReactNode; title?: string }) {
  return (
    <div className="flex flex-col gap-4">
      <span className="typo-subtitle-subtitle1 text-secondary">{title}</span>
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
